<template>
	<div class="pending_wrap">
    <step-status :step="$route.meta.step" class="mt55"></step-status>

		<h1>Pending result</h1>
		<div class="letter">
			<p>Dear {{full_name}},</p>
			<p>Thank you for completing all of the steps in the application,interview,and training stages,this is the final total teacher profile check performed to ensure the requirements and qualifications of new teachers meet the overall standards prior to being added to the system. You will receive a feedback from our team within 3 business days.</p>
			<p>Best,<br/>The HAWO Recruitment Team</p>
		</div>
		<!-- Google pixel -->
		<div style="display:inline;" v-if='$route.query.status=="passed"'>
		<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=dFR5CIzryngQu9OslgM&amp;guid=ON&amp;script=0"/>
		</div>
	</div>
</template>
<script>
export default {
 	props: {
 	},
  	data(){
	  	return {
	  		full_name:''
	  	}
  	},
  	created(){
	    //获取full_name
	    this.$http.get('/interview/getTutorProfile')
		.then((d)=>{
			if(d.data.code='75000'){
				this.full_name=d.data.res.tutor.full_name;
			}
		})
	}
}
</script>
<style lang='less' scoped>
	.pending_wrap{
		height:752px;
		width:1000px;
		margin:0 auto;
		&>h1{
			margin-top:55px;
			font-size:24px;
			font-weight:bolf;
			color:#ffb400;
		}
		div.letter{
			box-sizing: border-box;
			height:384px;
			background:#f7f7f7;
			border-radius: 10px;
			margin-top:30px;
			padding:40px 30px;
			p{
				padding-bottom: 24px;
				line-height: 20px;
				color:#1e1e1e;
				a{
					color: #fd4c6e;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// pass.vue?bd540286